var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTextFiledIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.280274 0.0800781H11.7195L11.738 3.9117H11.1907C11.0113 2.54481 10.4979 1.62015 9.65059 1.13772C9.17435 0.871762 8.46307 0.726414 7.51676 0.701674V10.7029C7.51676 11.4018 7.63737 11.8657 7.87858 12.0945C8.12598 12.3233 8.63625 12.4378 9.40938 12.4378V12.9202H2.63677V12.4378C3.37897 12.4378 3.87068 12.3233 4.1119 12.0945C4.3593 11.8595 4.483 11.3956 4.483 10.7029V0.701674C3.55525 0.726414 2.84397 0.871762 2.34917 1.13772C1.43997 1.63252 0.926609 2.55718 0.809094 3.9117H0.261719L0.280274 0.0800781Z",
    fill: "#151918",
    fillOpacity: 0.9
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextFiledIcon);
export default __webpack_public_path__ + "static/media/TextFiledIcon.b844caf839e5f2000a7639eb62cb4b11.svg";
export { ForwardRef as ReactComponent };